import { CAL_DESKTOP_ELEMENT_MNG } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: CAL_DESKTOP_ELEMENT_MNG,
  sortArr: [
    // {
    //   fieldName: 'createTime',
    //   direction: 'DESC'
    // },
    {
      fieldName: 'name',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  // relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['name'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'desktopElementCreate'
      }
    ]
  },

  view: {
    columns: [
      {
        props: {
          label: '名称',
          prop: 'name',
          sortField: 'name'
        }
      },
      {
        props: {
          label: '行业',
          prop: 'industryName',
          sortField: 'industryName'
        }
      },
      {
        props: {
          label: '软件版本',
          prop: 'softVersion',
          sortField: 'softVersion'
        }
      },
      {
        props: {
          label: '影响桌面配置的类型',
          prop: 'type',
          sortField: 'type'
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '素材大小(MB)',
          prop: 'materialDesc',
          sortField: 'materialDesc'
        }
      },
      {
        props: {
          label: 'cpu主频(GHZ)',
          prop: 'cpuSpeed',
          sortField: 'cpuSpeed'
        }
      },
      {
        props: {
          label: 'cpu核数',
          prop: 'cpuCore',
          sortField: 'cpuCore'
        }
      },
      {
        props: {
          label: '内存大小(G)',
          prop: 'memory',
          sortField: 'memory'
        }
      },
      {
        props: {
          label: '显存大小(G)',
          prop: 'videoMemory',
          sortField: 'videoMemory'
        }
      },
      {
        props: {
          label: 'iops大小',
          prop: 'iops',
          sortField: 'iops'
        }
      },
      {
        props: {
          label: '系统盘大小(G)',
          prop: 'systemDiskSize',
          sortField: 'systemDiskSize'
        }
      },
      {
        props: {
          label: '数据盘大小(G)',
          prop: 'dataDiskSize',
          sortField: 'dataDiskSize'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '1'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'desktopElementEdit',
        name: 'edit'
      }
    ]
  }
}
